import { useTranslation } from 'react-i18next';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { z } from 'zod';

export default function useFormContactSMESchema() {
  const { t } = useTranslation();
  return z.object({
    company: z.union([
      z.string().max(300, t('form.contact.sme.company.error')),
      z.literal(''),
    ]),
    tva: z.union([
      z
        .string()
        .min(5, t('form.contact.sme.tva.error'))
        .max(100, t('form.contact.sme.tva.error'))
        .optional(),
      z.literal(''),
    ]),
    firstName: z
      .string()
      .min(2, t('form.contact.sme.firstName.error'))
      .max(30, t('form.contact.sme.firstName.error')),
    lastName: z
      .string()
      .min(2, t('form.contact.sme.lastName.error'))
      .max(30, t('form.contact.sme.lastName.error')),
    email: z.string().email(t('form.contact.sme.email.error')),
    phone: z.string().refine(
      (value) => {
        if (!value || !isValidPhoneNumber(value)) {
          return false;
        }
        return true;
      },
      {
        message: t('form.contact.sme.phone.error'),
      }
    ),
  });
}

export type FormContactSMESchema = z.infer<
  ReturnType<typeof useFormContactSMESchema>
>;
